package exception

class NotesOverlappingException : Throwable(
    "Failed to process because there are notes overlapping with each other.",
)
